<template>
  <v-container fluid>    
    <slot name="navigation" />
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <employee-profile-card
            ref="profile"
            :employee-uid="employeeUid"
          />

          <employee-profile-container-view
            :employee-uid="employeeUid"
            :user-uid="userUid"
            @updated="refreshProfileCard"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container> 
</template>

<script>
  export default {
    components: {
      EmployeeProfileCard: () => import('@/components/hris/employee/ProfileCard'),
      EmployeeProfileContainerView: () => import('@/components/hris/employee/profile/ContainerView'),
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
      personUid: {
        type: String,
        default: '',
      },
      userUid: {
        type: String,
        default: '',
      },
    },
    methods: {
      refreshProfileCard () {
        this.$refs.profile.loadEmployee()
      },
    },
  }
</script>
